"use client";

import { useState } from "react";
import { SEOFriendlyDrawer } from "../__shared__/SEOFriendlyDrawer/SEOFriendlyDrawer";
import Tooltip from "@JohnLewisPartnership/jl-design-system/dist/components/tooltip/Tooltip";
import { Trigger } from "../__shared__/Trigger/Trigger";
import { Attribute } from "@/types/prodcatBaseTypes";
import styles from "./MeasurementsSideDrawer.module.scss";
import { withSideDrawerAnalytics } from "@/components/ProductSideDrawers/withSideDrawerAnalytics.tsx";

export type Props = {
  attributes: Attribute[];
};

export const MeasurementsSideDrawerUI = ({ attributes }: Props) => {
  const [open, setOpen] = useState(false);
  const defaultHelpText = "Height, Width, Depth";

  if (attributes.length < 1) {
    return null;
  }

  return (
    <>
      <Trigger
        label="Measurements"
        onClick={withSideDrawerAnalytics("Measurements", () => setOpen(true))}
      />
      <SEOFriendlyDrawer
        isOpen={open}
        onClose={() => {
          setOpen(false);
        }}
        heading="Measurements"
      >
        <div data-testid="product:measurements:sidedrawer">
          <dl data-testid="product:measurements:list">
            {attributes.map((measurement) => (
              <div className={styles.measurement} key={measurement.key}>
                <dt
                  className={styles.measurementTitle}
                  data-testid="product:measurements:list:label"
                >
                  <span>{measurement.displayName}</span>
                  <ProductAttributeToolTip
                    helpText={measurement.helpText || defaultHelpText}
                    toolTipId={measurement.key}
                  />
                </dt>
                <dd
                  className={styles.measurementValue}
                  data-testid="product:measurements:list:value"
                >
                  {measurement.values[0]}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </SEOFriendlyDrawer>
    </>
  );
};

function ProductAttributeToolTip({
  helpText,
  toolTipId,
}: {
  helpText: string;
  toolTipId: string;
}) {
  return (
    <div
      data-testid="product:measurements:list:label:tooltip"
      className={styles.tooltipWrapper}
    >
      <Tooltip id={`tooltip-${toolTipId}`} icon verticalAnchor="top">
        {helpText}
      </Tooltip>
    </div>
  );
}
